import React from "react";
import "../../styles/components/sharing/SharingMobile.scss";
import FinalReadingModal from "../reading/FinalReadingModal";
import ErrorModal from "../utils/modal/ErrorModal";
import AudioBookSelectionModal from "../audiobook/AudioBookSelectionModal";

const AudioSharingMobile = ({
  index,
  setIndex,
  story: storyData,
  bookData,
  handleButtonClick,
  handleExit,
  showFinalReadingModal,
  setShowFinalReadingModal,
  showErrorModal,
  errorMessage,
  setShowErrorModal,
  audioRef,
  pageName,
  navigate,
  bgImage,
  contentText,
  showAudioBookModal,
  setShowAudioBookModal,
  audioBookList,
  handleSelectAudioBook,
  handleDeleteAudioBooks,
  bookID,
  isBookOpened,
  setIsBookOpened,
  showFlipbook,
  setShowFlipbook,
  showTitleOnCover,
  setShowTitleOnCover,
  encryptUrlSafe,
  isPlaying,
  setIsPlaying,
  handleAudioToggle,
}) => {
  const [showControls, setShowControls] = React.useState(false);
  const [isLandscape, setIsLandscape] = React.useState(
    window.innerWidth > window.innerHeight,
  );
  const [showRotationModal, setShowRotationModal] = React.useState(false);
  const touchStartX = React.useRef(0);
  const controlsTimerRef = React.useRef(null);
  const lastIndexRef = React.useRef(index);

  const isNovel =
    bookData?.style === "graphic_novel" || bookData?.style === "그림 소설";

  const isCover = index === -1;

  React.useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    if (lastIndexRef.current === -1 && index === 0) {
      setShowRotationModal(true);
    }
    lastIndexRef.current = index;
  }, [index]);

  React.useEffect(() => {
    if (audioRef.current && !isCover) {
      if (showRotationModal && !isLandscape) {
        audioRef.current.pause();
      } else if (!showRotationModal || isLandscape) {
        audioRef.current.play().catch((err) => {
          console.warn("오디오 자동 재생이 차단되었습니다:", err);
          setIsPlaying(false);
        });
      }
    }
  }, [showRotationModal, isLandscape, isCover]);

  React.useEffect(() => {
    if (isLandscape && showRotationModal) {
      setShowRotationModal(false);
    }
  }, [isLandscape, showRotationModal]);

  const stopControlsTimer = (e) => {
    if (e) e.stopPropagation();
    if (controlsTimerRef.current) clearTimeout(controlsTimerRef.current);
  };

  const startControlsTimer = (e) => {
    if (e) e.stopPropagation();
    stopControlsTimer();
    controlsTimerRef.current = setTimeout(() => {
      setShowControls(false);
    }, 3000);
  };

  React.useEffect(() => {
    if (showControls) {
      startControlsTimer();
    } else {
      stopControlsTimer();
    }

    return () => {
      stopControlsTimer();
    };
  }, [showControls]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diffX = touchStartX.current - touchEndX;
    if (Math.abs(diffX) > 50) {
      if (diffX > 0) handleButtonClick("right");
      else handleButtonClick("left");
    }
  };

  const totalPages = storyData?.length || 0;
  const progressPercentage =
    totalPages > 0 ? Math.round(((index + 1) / totalPages) * 100) : 0;

  const showCoverLayer = isCover || (index === 0 && isBookOpened);

  const handleContainerClick = (e) => {
    if (isCover) return;
    const screenWidth = window.innerWidth;
    const clickX = e.clientX;

    if (clickX < screenWidth * 0.3) handleButtonClick("left");
    else if (clickX > screenWidth * 0.7) handleButtonClick("right");
    else setShowControls(!showControls);
  };

  const handleCoverClick = () => {
    if (isBookOpened) return;
    setIsBookOpened(true);

    setTimeout(() => {
      setIndex(0);

      setTimeout(() => {
        setIsBookOpened(false);
      }, 400);
    }, 600);
  };

  return (
    <div
      className={`sharing-mobile-container ${isCover ? "is-cover" : "is-reading"} ${isBookOpened ? "is-opening" : ""} ${isNovel ? "novel-style" : "drawing-style"} ${isLandscape ? "is-landscape" : "is-portrait"} ${showControls ? "show-controls" : ""}`}
      onClick={handleContainerClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {}
      {!isCover && (
        <>
          {!isLandscape && (
            <div className="reading-view-logo">
              <img src="/images/logo/story4u-logo.svg" alt="STORY4U" />
            </div>
          )}

          <section className="mobile-stories-section">
            <div
              key={index}
              className={`mobile-story-card ${isNovel ? "novel-style" : "general-style"} ${isBookOpened ? "content-fade-in" : ""}`}
            >
              <button
                className={`mobile-audio-toggle-top ${isPlaying ? "playing" : "paused"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAudioToggle();
                }}
              >
                <img
                  src={`/images/sharing/mobile/${isPlaying ? "pause-btn" : "mobile_audio"}.svg`}
                  alt="audio"
                />
              </button>

              {isLandscape && !isNovel && (
                <div className="general-top-logo">
                  <img src="/images/logo/story4u-logo.svg" alt="STORY4U" />
                </div>
              )}

              <div className="mobile-story-image-wrap">
                <img src={bgImage} alt="story" className="mobile-story-image" />
              </div>
              <div className="mobile-story-content">
                <p className="mobile-story-text">
                  {Array.isArray(contentText)
                    ? contentText.join(" ")
                    : contentText}
                </p>
                {isLandscape && isNovel && (
                  <div className="landscape-logo">
                    <img src="/images/logo/story4u-logo.svg" alt="STORY4U" />
                  </div>
                )}
              </div>
            </div>
          </section>

          {!isBookOpened && (
            <>
              <div
                className="mobile-reading-controls"
                onClick={(e) => e.stopPropagation()}
                onMouseDown={stopControlsTimer}
                onMouseUp={startControlsTimer}
                onMouseLeave={startControlsTimer}
                onTouchStart={stopControlsTimer}
                onTouchEnd={startControlsTimer}
                onTouchMove={(e) => e.stopPropagation()}
              >
                <div className="controls-header">
                  <h3 className="controls-book-title">{bookData?.title}</h3>
                </div>

                <div className="controls-progress-wrapper">
                  <div className="progress-bar-container">
                    <input
                      type="range"
                      min="0"
                      max={totalPages - 1}
                      value={index}
                      onChange={(e) => setIndex(parseInt(e.target.value, 10))}
                      className="progress-range-slider"
                    />
                  </div>
                  <div className="controls-info">
                    <span className="page-count">
                      <span className="current-page">{index + 1}</span> /{" "}
                      {totalPages}
                    </span>
                    <span className="percentage-text">
                      {progressPercentage}%
                    </span>
                  </div>
                </div>
                <button
                  className={`mobile-audio-toggle-bottom ${isPlaying ? "playing" : "paused"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAudioToggle();
                  }}
                >
                  <img
                    src={`/images/sharing/mobile/${isPlaying ? "pause-btn" : "mobile_audio"}.svg`}
                    alt="audio"
                  />
                </button>
              </div>

              <div className="portrait-page-indicator">
                <span className="current">{index + 1}</span> / {totalPages}
              </div>
            </>
          )}
        </>
      )}

      {}
      {showCoverLayer && (
        <div
          className={`mobile-cover-overlay ${isNovel ? "novel-style" : "drawing-style"} ${isBookOpened ? "animating" : ""}`}
        >
          {isNovel ? (
            /* ============================================================
               그림 소설 (Novel) 전용 표지 에셋 및 레이아웃
               ============================================================ */
            <div className="novel-cover-wrap">
              {isLandscape ? (
                <>
                  <div className="landscape-lamps">
                    <div className="lamp-left">
                      <img src="/images/sharing/mobile/lamp-hor.svg" alt="" />
                    </div>
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 소설을</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <div className="landscape-ornaments">
                    <img
                      src="/images/sharing/mobile/bottom-nikki-hor.svg"
                      alt=""
                      className="nikki-hor"
                    />
                  </div>
                  <div className="landscape-bottom-logos">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                      className="magic4u-logo-hor"
                    />
                    <img
                      src="/images/logo/story4u-logo.svg"
                      alt="STORY4U"
                      className="story4u-logo-hor"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mobile-lamps">
                    <img
                      src="/images/sharing/mobile/lamp.svg"
                      alt=""
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="mobile-logo">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                    />
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 소설을</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <img
                    src="/images/sharing/mobile/bottom-nikki.svg"
                    alt="bottom ornament"
                    className="bottom-nikki-bg"
                  />
                  <img
                    src="/images/logo/story4u-logo.svg"
                    alt="story4u logo"
                    className="bottom-story4u-logo"
                  />
                </>
              )}

              <div
                className={`cover-flip-wrapper ${isBookOpened ? "opened" : ""}`}
                onClick={handleCoverClick}
              >
                <div className="book-shelf-cover">
                  <div className="result-book-container">
                    <div className="result-book">
                      <div className="cover-content">
                        <img src={bookData?.bookcover} alt="cover" />
                        <h2
                          className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                        >
                          {bookData?.title}
                        </h2>
                      </div>
                    </div>
                    <figure className="result-book-left">
                      <img
                        src="/images/utils/modal/novelFinalModal/book-left.svg"
                        alt="spine"
                      />
                    </figure>
                    <figure className="result-book-bottom">
                      <img
                        src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                        alt="pages"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            /* ============================================================
               그림 동화 (Drawing) 전용 표지 에셋 및 레이아웃
               ============================================================ */
            <div className="drawing-cover-wrap">
              <div className="drawing-top-assets">
                <img
                  src="/images/sharing/mobile/book-asset1.svg"
                  alt=""
                  className="top-left-asset"
                />
                <img
                  src="/images/sharing/mobile/book-arial.svg"
                  alt=""
                  className="top-right-asset"
                />
                <img
                  src="/images/sharing/mobile/book-nikki.svg"
                  alt=""
                  className="bottom-left-asset"
                />
                <img
                  src="/images/sharing/mobile/book-asset2.svg"
                  alt=""
                  className="bottom-right-asset"
                />
              </div>

              {isLandscape ? (
                <>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 동화를</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <div className="landscape-ornaments">
                    <img
                      src="/images/sharing/mobile/book-bottom-hor.webp"
                      alt=""
                      className="nikki-hor"
                    />
                  </div>
                  <div className="landscape-bottom-logos">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                      className="magic4u-logo-hor"
                    />
                    <img
                      src="/images/logo/story4u-logo.svg"
                      alt="STORY4U"
                      className="story4u-logo-hor"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mobile-logo">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                    />
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 동화를</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <img
                    src="/images/sharing/mobile/book-bottom.webp"
                    alt="bottom ornament"
                    className="bottom-nikki-bg"
                  />
                  <img
                    src="/images/logo/story4u-logo.svg"
                    alt="story4u logo"
                    className="bottom-story4u-logo"
                  />
                </>
              )}

              <div
                className={`cover-flip-wrapper ${isBookOpened ? "opened" : ""}`}
                onClick={handleCoverClick}
              >
                <div className="book-shelf-cover">
                  <div className="result-book-container">
                    <div className="result-book">
                      <div className="cover-content">
                        <img src={bookData?.bookcover} alt="cover" />
                        <h2
                          className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                        >
                          {bookData?.title}
                        </h2>
                      </div>
                    </div>
                    <figure className="result-book-left">
                      <img
                        src="/images/sharing/mobile/book-left.svg"
                        alt="spine"
                      />
                    </figure>
                    <figure className="result-book-bottom">
                      <img
                        src="/images/sharing/mobile/book-shelf.svg"
                        alt="pages"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {}
      <audio
        ref={audioRef}
        playsInline
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      />

      {showRotationModal && !isLandscape && !isBookOpened && (
        <div
          className="rotation-guide-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <button
              className="modal-close-btn"
              onClick={() => setShowRotationModal(false)}
            >
              <img src="/images/utils/modal/close.svg" alt="" />
              <span>닫기</span>
            </button>
          </div>
          <div className="modal-content">
            <h2 className="rotation-guide-title">
              핸드폰을 가로로 돌려서 보면
              <br />더 편하게 볼 수 있어요!
            </h2>
            <img
              src={`/images/sharing/mobile/${isNovel ? "novel-modal" : "drawing-modal"}.svg`}
              alt="Rotate your phone"
            />
          </div>
        </div>
      )}

      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => {
            setShowFinalReadingModal(false);
            setIndex(-1);
          }}
          pageName={pageName}
          onClose={handleExit}
          isMobile={true}
        />
      )}

      {showErrorModal && (
        <ErrorModal
          error_message={errorMessage}
          onClose={() => {
            setShowErrorModal(false);
            navigate("/storyland");
          }}
        />
      )}

      {showAudioBookModal && (
        <AudioBookSelectionModal
          audiobooks={audioBookList}
          onSelect={handleSelectAudioBook}
          onClose={() => {
            setShowAudioBookModal(false);
            window.close();
          }}
          bookID={bookID}
          onReadTextBook={() => {
            navigate(`/share?book_id=${encryptUrlSafe(bookID)}`, {
              state: {
                pageName,
                bookID,
              },
            });
          }}
          onDeleteSelected={handleDeleteAudioBooks}
        />
      )}

      {}
      <div
        className={`transition-fade-overlay ${isBookOpened ? "active" : ""}`}
      />
    </div>
  );
};

export default AudioSharingMobile;
